const ACTIVE_OSS_ORIGIN = 'https://yytc-img.oss-cn-qingdao.aliyuncs.com'
const MEDIA_VALUE_KEYS = ['url', 'src', 'path', 'fileUrl', 'previewUrl', 'relativeUrl']

function getFirstMediaValue(value, depth) {
  const currentDepth = Number(depth) || 0
  if (value === null || value === undefined || currentDepth > 5) {
    return ''
  }
  if (Array.isArray(value)) {
    for (let index = 0; index < value.length; index += 1) {
      const itemValue = getFirstMediaValue(value[index], currentDepth + 1)
      if (itemValue) {
        return itemValue
      }
    }
    return ''
  }
  if (typeof value === 'object') {
    for (let index = 0; index < MEDIA_VALUE_KEYS.length; index += 1) {
      const itemValue = value[MEDIA_VALUE_KEYS[index]]
      if (itemValue) {
        return getFirstMediaValue(itemValue, currentDepth + 1)
      }
    }
    return ''
  }

  const text = String(value).trim()
  if (!text || text === 'null' || text === 'undefined') {
    return ''
  }
  if ((text[0] === '[' && text[text.length - 1] === ']') ||
      (text[0] === '{' && text[text.length - 1] === '}') ||
      (text[0] === '"' && text[text.length - 1] === '"')) {
    try {
      const parsed = JSON.parse(text)
      if (parsed !== text) {
        return getFirstMediaValue(parsed, currentDepth + 1)
      }
    } catch (error) {}
  }
  return text
}

function normalizeAdminMediaUrl(value) {
  let url = getFirstMediaValue(value)
  if (!url) {
    return ''
  }
  url = url.replace(/&amp;/g, '&').replace(/^httpss:/i, 'https:')
  if (/^\/\//.test(url)) {
    url = 'https:' + url
  }
  return url
    .replace(/^https?:\/\/oss\.youkutongcheng\.com(?=\/|$)/i, ACTIVE_OSS_ORIGIN)
    .replace(/^http:\/\/yytc-img\.oss-cn-qingdao\.aliyuncs\.com(?=\/|$)/i, ACTIVE_OSS_ORIGIN)
}

export {
  ACTIVE_OSS_ORIGIN,
  getFirstMediaValue,
  normalizeAdminMediaUrl
}



// WEBPACK FOOTER //
// ./src/utils/adminMediaUrl.js